import React, { useState, useCallback } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import { connect } from 'react-redux';
import { patchUser } from 'redux/settings/actions';

import { Checkbox } from 'semantic-ui-react';

import './AnonymousMessagesSwitcher.css';

const AnonymousMessagesSwitcher = ({ me, patchUser }) => {
  const [ isChecked, setChecked ] = useState(me.messages_is_active);
  const { t } = useTranslation();
  const checkboxChange = useCallback((_e, { checked }) => {
    const form = new FormData();
    form.append('messages_is_active', checked);
    setChecked(checked);
    patchUser(form);
  }, []);

  if (!me) return null;

  return (
    <div className="anonymous-messages-switcher__component">
      <p>{t("Turn ON / OFF Message")}</p>

      <div className="switcher-wrapper">
        <span>{t("OFF")}</span>
        <Checkbox
          toggle
          checked={isChecked}
          onChange={checkboxChange}
        />
        <span>{t("ON")}</span>
      </div>
    </div>

  );
};

AnonymousMessagesSwitcher.propTypes = {
  me: PropTypes.object,
  patchUser: PropTypes.func,
};
AnonymousMessagesSwitcher.defaultProps = {
  me: null,
  patchUser: null,
};

const mapStateToProps = state => (
  {
    me: state.usersReducer.me,
  }
);

export default connect(
  mapStateToProps,
  {
    patchUser,
  },
)(AnonymousMessagesSwitcher);
